// Cache keys used for react-query
export enum ReactQueryKeys {
  APPOINTMENTS = "APPOINTMENTS",
  APPOINTMENT_TYPES = "APPOINTMENT_TYPES",
  BARNARD_CONVERSATION = "BARNARD_CONVERSATION",
  BARNARD_CONVERSATIONS = "BARNARD_CONVERSATIONS",
  BARNARD_CONVERSATIONS_ALL = "BARNARD_CONVERSATIONS_ALL",
  CALENDARS = "CALENDARS",
  CONTENTFUL_CAPABLE_ENTRIES = "CONTENTFUL_CAPABLE_ENTRIES",
  CONTENTFUL_INTEGRATION = "CONTENTFUL_INTEGRATION",
  CONVERSATION_PARTICIPANTS = "CONVERSATION_PARTICIPANTS",
  CONVERSATION_PATIENT_PARTICIPANTS = "CONVERSATION_PATIENT_PARTICIPANTS",
  CONVERSATIONS = "CONVERSATIONS",
  CONVERSATIONS_ALL = "CONVERSATIONS_ALL",
  CLEARANCE = "CLEARANCE",
  CLEARANCES = "CLEARANCES",
  COMORBIDITY = "COMORBIDITY",
  COMORBIDITIES = "COMORBIDITIES",
  CURRENT_USER = "CURRENT_USER",
  DASHBOARD_STATS = "DASHBOARD_STATS",
  DASHBOARD_SURGERIES = "DASHBOARD_SURGERIES",
  ESCALATION_BOARD = "ESCALATION_BOARD",
  GOALS = "GOALS",
  HOSPITAL = "HOSPITAL",
  HOSPITALS = "HOSPITALS",
  INBOX = "INBOX",
  CONVERSATION_INBOX = "CONVERSATION_INBOX",
  INSURANCE_CLAIM = "INSURANCE_CLAIM",
  INSURANCE_CLAIMS = "INSURANCE_CLAIMS",
  INTEGRATIONS = "INTEGRATIONS",
  INTEGRATIONS_ACUITY = "INTEGRATIONS_ACUITY",
  LAB_TEST_ORDERS = "LAB_TEST_ORDERS",
  MESSAGES = "MESSAGES",
  MEDICAL_TERM = "MEDICAL_TERM",
  OBSERVATION_TYPE = "OBSERVATION_TYPE",
  OBSERVATION_TYPES = "OBSERVATION_TYPES",
  OBSERVATION_TYPE_GROUPS = "OBSERVATION_TYPE_GROUPS",
  PATIENT = "PATIENT",
  PATIENTS = "PATIENTS",
  PATIENT_ALLERGENS = "PATIENT_ALLERGENS",
  PATIENT_ATTACHMENTS = "PATIENT_ATTACHMENTS",
  PATIENT_BARNARD_CONVERSATIONS = "PATIENT_BARNARD_CONVERSATIONS",
  PATIENT_CARE_PROGRESS = "PATIENT_CARE_PROGRESS",
  PATIENT_ENCOUNTER = "PATIENT_ENCOUNTER",
  PATIENT_OBSERVATIONS = "PATIENT_OBSERVATIONS",
  PATIENT_RELATED_PERSONS = "PATIENT_RELATED_PERSONS",
  PATIENT_REMINDER_TEMPLATES = "PATIENT_REMINDER_TEMPLATES",
  PATIENT_STATUS_HISTORY = "PATIENT_STATUS_HISTORY",
  PERMISSION_VIEW = "PERMISSION_VIEW",
  PRACTITIONERS = "PRACTITIONERS",
  PRACTITIONERS_AND_TENANT_ADMINS_DATA = "PRACTITIONERS_AND_TENANT_ADMINS_DATA",
  QUESTIONNAIRE = "QUESTIONNAIRE",
  QUESTIONNAIRES = "QUESTIONNAIRES",
  REFERRING_PROVIDERS = "REFERRING_PROVIDERS",
  SUBMISSIONS = "SUBMISSIONS",
  OUTREACH_ASSIGNEE = "OUTREACH_ASSIGNEE",
  OUTREACH_ASSIGNEES = "OUTREACH_ASSIGNEES",
  SURGEON = "SURGEON",
  SURGEONS = "SURGEONS",
  SURVEY = "SURVEY",
  SERVICE_LINE = "SERVICE_LINE",
  SERVICE_LINES = "SERVICE_LINES",
  EMAIL_TEMPLATES = "EMAIL_TEMPLATES",
  SMS_TEMPLATES = "SMS_TEMPLATES",
  SURGERY_TYPE = "SURGERY_TYPE",
  SURGERY_TYPES = "SURGERY_TYPES",
  TAG = "TAG",
  TAGS = "TAGS",
  TARGETS = "TARGETS",
  TASK = "TASK",
  TASKS = "TASKS",
  TASK_TEMPLATE = "TASK_TEMPLATE",
  TASK_TEMPLATES = "TASK_TEMPLATES",
  TWILIO_CLIENT = "TWILIO_CLIENT",
  TWILIO_CONVERSATION = "TWILIO_CONVERSATION",
  TWILIO_CONVERSATIONS = "TWILIO_CONVERSATIONS",
  TWILIO_TOKEN = "TWILIO_TOKEN",
  USER_CAN = "USER_CAN",
  USERS = "USERS",
  VIDEO_LINK = "VIDEO_LINK",
  VIDEO_TOKEN = "VIDEO_TOKEN",
}
